export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[650px] md:min-h-[750px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=Luxurious%20dark%20golden%20casino%20interior%20with%20elegant%20chandeliers%20and%20warm%20amber%20lighting%2C%20dramatic%20atmospheric%20photography%2C%20velvet%20curtains%2C%20golden%20accents%2C%20mysterious%20upscale%20ambiance&width=1920&height=1080&seq=hero-bg-main&orientation=landscape)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/60 via-background-950/40 to-background-950"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/10 border border-primary-500/20 mb-6">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-vip-crown-fill text-primary-400 text-sm"></i>
            </div>
            <span className="text-sm text-primary-300 font-medium">2024年度最佳在线娱乐平台</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-50 leading-tight">
            顶级娱乐体验
            <br />
            <span className="text-primary-400">尽在金沙娱乐</span>
          </h1>

          <p className="mt-6 text-base md:text-lg text-foreground-400 max-w-2xl mx-auto leading-relaxed">
            金沙娱乐是您首选的顶级在线娱乐平台，提供丰富的游戏种类、安全可靠的支付环境与24小时专属客服。
            无论您热爱电子游戏、真人荷官还是体育竞技，金沙娱乐都能满足您的一切娱乐需求。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
            <a
              href="#"
              className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold text-background-950 bg-primary-500 hover:bg-primary-400 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              立即注册
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href="#categories"
              className="w-full sm:w-auto px-8 py-3.5 text-base font-medium text-foreground-200 border border-background-500/40 hover:border-foreground-400/50 hover:text-foreground-50 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              探索游戏
              <i className="ri-arrow-down-line ml-2"></i>
            </a>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 mt-12 md:mt-16 max-w-3xl mx-auto">
            <div className="bg-background-900/60 backdrop-blur-sm rounded-xl p-4 border border-background-700/20">
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">500+</div>
              <div className="text-xs md:text-sm text-foreground-500 mt-1">精品游戏</div>
            </div>
            <div className="bg-background-900/60 backdrop-blur-sm rounded-xl p-4 border border-background-700/20">
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">200万+</div>
              <div className="text-xs md:text-sm text-foreground-500 mt-1">注册用户</div>
            </div>
            <div className="bg-background-900/60 backdrop-blur-sm rounded-xl p-4 border border-background-700/20">
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">24/7</div>
              <div className="text-xs md:text-sm text-foreground-500 mt-1">专属客服</div>
            </div>
            <div className="bg-background-900/60 backdrop-blur-sm rounded-xl p-4 border border-background-700/20">
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">SSL</div>
              <div className="text-xs md:text-sm text-foreground-500 mt-1">安全加密</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-foreground-500 text-xl"></i>
        </div>
      </div>
    </section>
  );
}